export default "__VITE_ASSET__C4f7SG59__"